/**
 *
 * Asynchronously loads the component for ModalConfirm
 * Author: TruongTX
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
